import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  blockUnblockedUser,
  deleteUser,
  fetchUsers,
} from "../redux/action/userAction";
import { pageRoutes } from "../routes/pageRoutes";
import { pipViewDate2 } from "../utils/pip";

const UserDescription = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isToggle } = useSelector((state) => state?.authReducer);

  const { selectedData } = location.state;

  const parseStringToArray = (str) =>
    str ? str.split(",").map((item) => item.trim()) : [];

  const lookingForArray = parseStringToArray(selectedData?.looking_for);
  const relationship_typeArray = parseStringToArray(
    selectedData?.relationship_type
  );
  const relationshipStatusArray = parseStringToArray(
    selectedData?.relationship_status
  );
  const ethnicityArray = parseStringToArray(selectedData?.ethnicity);
  const tagsArray = parseStringToArray(selectedData?.tags);
  const [isBlocked, setIsBlocked] = useState(selectedData?.is_blocked);
  const userImage = selectedData?.images?.[0] || "./user_profile2.png";

  const [showAllImages, setShowAllImages] = useState(false);

  const filteredImages = selectedData?.images.slice(
    1,
    selectedData?.images.length
  );
  const visibleImages = showAllImages
    ? filteredImages
    : filteredImages.slice(0, 6);

  const formattedLookingFor = (lookingFor) => {
    return lookingFor
      ? lookingFor
        .split(",")
        .map((part) => part.trim())
        .join(", ")
      : "";
  };

  const toggleBlockStatus = () => {
    const newBlockStatus = !isBlocked;
    setIsBlocked(newBlockStatus);
    handleBlockedStatus({
      user_id: selectedData?.id,
      block_status: newBlockStatus,
    });
  };

  const handleBlockedStatus = (values) => {
    const callback = (response) => {
      if (response.success) dispatch(fetchUsers());
    };
    dispatch(blockUnblockedUser({ payload: values, callback }));
  };

  const handleDeleteUser = (id) => {
    const callback = (response) => {
      if (response?.success) {
        navigate(pageRoutes?.users);
      }
    };
    dispatch(deleteUser({ payload: { user_id: id }, callback }));
  };

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />
          <div class="ct_inner_dashbaord_main">
            <div class="row ">
              {/* description code  */}
              <div className="col-md-12 mx-auto">
                <div className="ct_white_bg">
                  <div className="row">
                    <div className="col-xl-4 col-md-5 mb-4 mb-md-0">
                      <figure>
                        <div className="ct_user_img_1">
                          <div className="position-relative" style={{ overflow: "hidden" }}>
                            <img src={userImage} alt="" />
                            <span className="ct_full_access_ribbin">{selectedData?.account_type ?? ''}</span>
                          </div>
                          <div className="ct_unser_overlay_cnt">
                            <h4 className="ct_fs_20 ct_fw_600 mb-2">
                              {selectedData?.name ?? ""} , {selectedData?.age ?? 0}
                            </h4>
                            <p className="mb-0 ct_fw_500">
                              <i className="bi bi-geo-alt-fill me-1"></i>
                              {selectedData?.city ?? ''}, {selectedData?.country ?? ''}
                            </p>
                          </div>
                        </div>
                        <div className="ct_mt_20">
                          {selectedData?.username && (
                            <div
                              target="_blank"
                              className="d-flex align-items-center gap-2"
                            >
                              <i className="fa-regular fa-user fa-xs ct_orange_text"></i>
                              <span className="text-dark ct_fs_16">
                                {" "}
                                {selectedData?.username ?? ''}
                              </span>
                            </div>
                          )}
                          {selectedData?.phone_number && (
                            <a
                              target="_blank"
                              className="d-flex align-items-center gap-2"
                            >
                              <i className="bi bi-telephone ct_fs_16 ct_orange_text"></i>
                              <span className="text-dark ct_fs_16">
                                {" "}
                                {selectedData?.phone_number}
                              </span>
                            </a>
                          )}
                          {selectedData?.email && (
                            <a
                              target="_blank"
                              className="d-flex align-items-center gap-2 mt-2"
                            >
                              <i className="bi bi-envelope ct_fs_16 ct_orange_text"></i>
                              <span className="text-dark ct_fs_16">
                                {" "}
                                {selectedData?.email}
                              </span>
                            </a>
                          )}
                          {selectedData?.last_seen && (
                            <div className="d-flex align-items-center gap-2">
                              <i
                                class="fa-solid fa-circle fa-xs ct_orange_text"
                                style={{ color: "#18cd45" }}
                              ></i>

                              <p className="mb-0 ct_fw_600 ct_fs_16">
                                Last Connection{" "}
                                <span className="text-dark ct_fs_16">
                                  {" "}
                                  {pipViewDate2(selectedData?.last_seen)}
                                </span>
                              </p>
                            </div>
                          )}
                        </div>
                        {selectedData?.about_me &&
                          selectedData?.about_me != 0 && (
                            <figcaption className="ct_mt_20">
                              <h4 className="ct_fs_16 ct_fw_600">About</h4>
                              <p className="mb-0 ct_fs_16">
                                {selectedData?.about_me}
                              </p>
                            </figcaption>
                          )}
                      </figure>
                      <div className="d-flex align-items-center gap-2 ct_mb_20">
                        <p className="mb-0 ct_fw_600 ct_fs_16">Block User</p>
                        <div className="form-check form-switch ms-auto">
                          <input
                            className="form-check-input ct_pointer_curser"
                            type="checkbox"
                            id="flexSwitchCheckChecked"
                            checked={isBlocked}
                            onChange={toggleBlockStatus}
                          />
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <p className="mb-0 ct_fw_600 ct_fs_16">Delete User</p>
                        <p className="mb-0 ct_red_text ms-auto">
                          <i
                            class="fa-solid fa-trash-can ct_pointer_curser"
                            data-bs-toggle="modal"
                            data-bs-target="#ct_delete_account_modal"
                          ></i>
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-8 col-md-7 mb-4 mb-md-0">
                      <div>
                        <div className="row">
                          <>
                            {visibleImages.map((item, index) => (
                              <div
                                className="col-xl-4 col-md-6 mb-3"
                                key={index}
                              >
                                <div className="ct_uper_multiple_snap">
                                  <img
                                    src={item}
                                    alt={`User image ${index + 1}`}
                                  />
                                  {/* If there are more than 4 images, show the "4+ Photos" span */}
                                  {index == 5 && !showAllImages && (
                                    <span
                                      className="ct_pointer_curser"
                                      onClick={() => setShowAllImages(true)}
                                    >
                                      +{filteredImages.length - 6} Photos
                                    </span>
                                  )}

                                  {showAllImages &&
                                    index === visibleImages.length - 1 && (
                                      <span
                                        className="ct_pointer_curser"
                                        onClick={() => setShowAllImages(false)}
                                      >
                                        Show Less
                                      </span>
                                    )}
                                </div>
                              </div>
                            ))}
                          </>
                        </div>
                        <div>
                          {selectedData?.looking_for &&
                            selectedData?.looking_for != 0 && (
                              <div class="ct_user_tags_div ct_mb_20">
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Looking for
                                </h4>
                                <ul>
                                  {lookingForArray.map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          {selectedData?.relationship_type &&
                            selectedData?.relationship_type != 0 && (
                              <div class="ct_user_tags_div ct_mb_20">
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Relation Type
                                </h4>
                                <ul>
                                  {relationship_typeArray.map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          {selectedData?.tags && selectedData?.tags != 0 && (
                            <div class="ct_user_tags_div ct_mb_20">
                              <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">Tags</h4>
                              <ul>
                                {tagsArray.map((item, index) => (
                                  <li key={index}>{item}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {selectedData?.relationship_status &&
                            selectedData?.relationship_status != 0 && (
                              <div class="ct_user_tags_div ct_mb_20">
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Relation Type
                                </h4>
                                <ul>
                                  {relationshipStatusArray.map(
                                    (item, index) => (
                                      <li key={index}>{item}</li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}
                          {selectedData?.sexual_orientation &&
                            selectedData?.sexual_orientation != 0 && (
                              <div class="ct_user_tags_div ct_mb_20">
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Sexual orientation
                                </h4>
                                <ul>
                                  <li>{selectedData?.sexual_orientation}</li>
                                </ul>
                              </div>
                            )}
                          {selectedData?.ethnicity &&
                            selectedData?.ethnicity != 0 && (
                              <div class="ct_user_tags_div ct_mb_20">
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Ethnicity
                                </h4>
                                <ul>
                                  {ethnicityArray.map((item, index) => (
                                    <li key={index}>{item}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          {selectedData?.gender &&
                            selectedData?.gender != 0 && (
                              <div class="ct_user_tags_div ct_mb_20">
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Gender
                                </h4>
                                <ul>
                                  <li>{selectedData?.gender}</li>
                                </ul>
                              </div>
                            )}
                          {selectedData?.pronouns &&
                            selectedData?.pronouns != 0 && (
                              <div class="ct_user_tags_div ct_mb_20">
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Pronouns
                                </h4>
                                <ul>
                                  <li>{selectedData?.pronouns}</li>
                                </ul>
                              </div>
                            )}

                          {selectedData?.height &&
                            selectedData?.height != 0 && (
                              <div class="ct_user_tags_div ct_mb_20">
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Height
                                </h4>
                                <ul>
                                  <li>{selectedData?.height}</li>
                                </ul>
                              </div>
                            )}

                          <div class="ct_user_tags_div ct_mb_20">
                            {(selectedData?.facebook_link ||
                              selectedData?.instagram_link ||
                              selectedData?.twitter_link ||
                              selectedData?.linkedIn_link) && (
                                <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                                  Social
                                </h4>
                              )}
                            <div className="d-flex align-items-center gap-4 flex-wrap">
                              {selectedData?.instagram_link && (
                                <a
                                  href={`https://www.instagram.com/${encodeURIComponent(
                                    selectedData?.instagram_link
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fa-brands fa-instagram ct_fs_20 text-dark"></i>
                                </a>
                              )}
                              {selectedData?.facebook_link && (
                                <a
                                  href={`https://www.facebook.com/${encodeURIComponent(
                                    selectedData?.facebook_link
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fa-brands fa-facebook ct_fs_20 text-dark"></i>
                                </a>
                              )}
                              {selectedData?.twitter_link && (
                                <a
                                  href={`https://www.twitter.com/${encodeURIComponent(
                                    selectedData?.twitter_link
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fa-brands fa-twitter ct_fs_20 text-dark"></i>
                                </a>
                              )}
                              {selectedData?.linkedIn_link && (
                                <a
                                  href={`https://www.twitter.com/${encodeURIComponent(
                                    selectedData?.linkedIn_link
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fa-brands fa-linkedin-in ct_fs_20 text-dark"></i>
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* delete modal start  */}
        <div
          class="modal fade ct_assets_modal"
          id="ct_delete_account_modal"
          tabindex="-1"
          aria-labelledby="ct_delete_modalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header border-0 pt-0">
                <button
                  type="button"
                  class="btn-close ct_cloose_btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div class="modal-body border-0 ">
                <i className="fa-solid fa-trash-can ct_red_text ct_fs_30 text-center d-block mb-4"></i>
                <h4 class="text-center mb-2 ct_fw_600">Confirm Delete</h4>
                <p className="text-center mb-0">
                  Are you sure? you want to delete it.
                </p>

                <div class="modal-footer border-0 justify-content-center">
                  <button
                    type="button"
                    class="ct_orange_btn ct_cancel_btn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <a
                    type="button"
                    class=" bg-danger  ct_orange_btn  justify-content-center"
                    style={{ borderColor: "rgb(220, 53, 69)" }}
                    data-bs-dismiss="modal"
                    onClick={() => handleDeleteUser(selectedData?.id)}
                  >
                    Delete
                  </a>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        {/* delete modal end */}
      </main>
    </>
  );
};

export default UserDescription;
